import { register as rregister } from '../../requests/loader';
/**
 * register by mail & password
 */

const byEmail = (params) => {
    const response = { success: false };
    const { password, accepterms = undefined, includpaywayprofile = undefined } = params;
    if(!accepterms) {
        params.accepterms = 1;
    }
    if(!includpaywayprofile) {
        params.includpaywayprofile = true;
    }
    if(params.password) {
        params.password = encodeURIComponent(password);
    }
    return new Promise((resolve, reject) => {
        rregister(params).then((result) => {
            if (result) {
                response.success = true;
                response.data = result.response;
                resolve(response);
            }
            else {
                response.response = result.response;
                response.success = false;
                reject(response);
            }
        }).catch((err) => {
            response.response = err;
            response.success = false;
            reject(response);
        });
    });
};

export const register = {
  byEmail
};



// WEBPACK FOOTER //
// ./src/AAF/Auth/register.js